import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=0b6ef0a0&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=0b6ef0a0&lang=scss&scoped=true&"
import style1 from "./Notifications.vue?vue&type=style&index=1&id=0b6ef0a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6ef0a0",
  null
  
)

export default component.exports